<form *ngIf="stampForm" [formGroup]="stampForm">

    <!-- Divider -->
    <mat-divider class="mt-6 mb-6"></mat-divider>

    <div class="row">
        <div class="col-sm-6" style="display: flex; justify-content: center;">
            <!-- CER -->
            <div class="text-center">
                <mat-label style=" font-size: 12px; font-weight: 600;">SUBE TU ARCHIVO .CER <span class="required">*</span></mat-label>
                <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos"
                    (uploaded)="fileBrowseHandlerCer($event)" [accept]="'.cer'" [title]="'Selecciona tu archivo .CER'">
                </app-upload-files>
        
                <ng-container *ngIf="loadCer">
                    <div class="d-flex align-items-center justify-content-center">
                        <mat-icon class="icon-size-5 text-primary"
                            [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                        <div class="ml-2">Archivo guardado.</div>
                    </div>
                </ng-container>
            </div>
        </div>
        
        <div class="col-sm-6 text-center"  style="display: flex; justify-content: center;">
            <!-- KEY -->
            <div class="">
                <mat-label style=" font-size: 12px; font-weight: 600;">SUBE TU ARCHIVO .KEY <span class="required">*</span></mat-label>
                <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos"
                    (uploaded)="fileBrowseHandlerKey($event)" [accept]="'.key'" [title]="'Selecciona tu archivo .KEY'">
                </app-upload-files>
                <ng-container *ngIf="loadKey">
                    <div class="d-flex align-items-center justify-content-center">
                        <mat-icon class="icon-size-5 text-primary"
                            [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                        <div class="ml-2">Archivo guardado.</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="row mt-8">
        <div class="col-sm-7"></div>
        <div class="col-sm-4">
            <div class="sm:col-span-2">
                <!-- Contraseña -->
                <mat-form-field>
                    <mat-label>Contraseña de los sellos digitales</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                    <input id="contrasenia" matInput type="password" [formControlName]="'contrasenia'" #passwordField>
                    <button mat-icon-button type="button"
                        (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                        matSuffix>
                        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                            [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                            [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                    </button>
                    <mat-error>
                        La contraseña es requerida
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    
    <!-- Divider -->
    <mat-divider class="mt-6 mb-6"></mat-divider>

    <!-- <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
        <div class="sm:col-span-2">
            <mat-label>Contraseña de los sellos digitales <span class="required">*</span></mat-label>
            <mat-form-field>
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                <input id="contrasenia" matInput type="password" [formControlName]="'contrasenia'" #passwordField>
                <button mat-icon-button type="button"
                    (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                    matSuffix>
                    <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                        [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                    <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                        [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                </button>
                <mat-error>
                    La contraseña es requerida
                </mat-error>
            </mat-form-field>
        </div>
        <div class="sm:col-span-1" *ngIf="files?.attributes?.cer">
            <mat-label>&nbsp;</mat-label>
            <button mat-button matTooltip="Descargar certificado CER" (click)="downloadFile(files.attributes.cer)">
                <mat-icon>download</mat-icon>
                cer.
            </button>
        </div>
        <div class="sm:col-span-1" *ngIf="files?.attributes?.key">
            <mat-label>&nbsp;</mat-label>
            <button mat-button matTooltip="Descargar certificado KEY" (click)="downloadFile(files.attributes.key)">
                <mat-icon>download</mat-icon>
                key.
            </button>
        </div>

    </div> -->

    <!-- <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
        <div class="col-span-2 sm:col-span-1 align-center">
            <mat-label>Número de certificado <div>{{noCertificado}}</div></mat-label>
        </div>
        <div class="col-span-2 sm:col-span-1 align-center">
            <mat-label>Vigencia <div>{{vigencia | date: 'dd-MM-yyyy'}}</div></mat-label>
        </div>
    </div> -->

    <!-- Actions -->
    <div class="flex items-center justify-end mt-5">
        <!-- <button class="ml-4" mat-flat-button type="button" [disabled]="!stampForm.valid" (click)="uploadFile()"
            [color]="'primary'"> Guardar
            Sellos Digitales
        </button> -->

        <!-- <button class="ml-4" mat-flat-button type="button" (click)="uploadFile()" [color]="'primary'"> 
            Test
        </button> -->
    </div>

</form>